export default __webpack_public_path__ + "static/media/DOCUMENTO_ICONA.83b0e70f.svg";